<script lang="ts" setup>
import { useClipboard } from "@vueuse/core";

const { template } = storeToRefs(useTemplateStore());
const toastNotification = useToastNotification();

const { copy, copied, isSupported } = useClipboard();

function onCopyAccountNumber(accountNumber: string) {
  if (!isSupported) {
    toastNotification.add("error", {
      title: "Gagal",
      description: "Fitur salin tidak didukung di perangkat Anda.",
    });

    return;
  }

  copy(accountNumber).then(() => {
    if (copied.value) {
      toastNotification.add("success", {
        title: "Berhasil",
        description: "Nomor rekening berhasil disalin ke clipboard.",
      });
    }
    else {
      throw new Error("Copy failed");
    }
  }).catch(() => {
    toastNotification.add("error", {
      title: "Gagal",
      description: "Terjadi kesalahan saat menyalin nomor rekening.",
    });
  });
}
</script>

<template>
  <section
    id="gift"
    class="px-section py-section-alt max-w-section flex flex-col gap-10 md:gap-14 lg:gap-16"
  >
    <AppSectionHeaderWrapper>
      <AppSectionTitle
        data-aos="fade-up"
        data-aos-delay="500"
        data-aos-anchor="#gift"
      >
        GIFT
      </AppSectionTitle>

      <NuxtImg
        src="/line-primary.svg"
        alt="Line Primary"
        data-aos="zoom-in"
        data-aos-delay="600"
        data-aos-anchor="#gift"
        class="w-line-graphic"
        loading="lazy"
        decoding="async"
      />
    </AppSectionHeaderWrapper>

    <div class="flex flex-col gap-8 text-center">
      <p
        class="text-sm mx-auto max-w-2xs xs:text-base xs:max-w-xs sm:max-w-sm xl:text-lg xl:max-w-md"
        data-aos="fade-up"
        data-aos-delay="750"
        data-aos-anchor="#gift"
      >
        Kasih, doa, dan kehadiran Anda adalah hadiah terindah bagi kami. Namun bila berkenan berbagi tanda kasih dengan metode cashless, Anda dapat mengirimkan melalui rekening di bawah ini:
      </p>
    </div>

    <ul
      class="grid grid-cols-1 sm:grid-cols-2 max-w- sm:max-w-md md:max-w-xl mx-auto gap-10 md:gap-16 xl:gap-20"
    >
      <li
        v-for="(bank, index) in template.gift.bank_accounts"
        :key="bank.account_number"
        class="flex flex-col gap-2 items-center justify-start"
        data-aos="fade-up"
        data-aos-anchor="#gift"
        :data-aos-delay="850 + index * 150"
      >
        <span class="inline-flex items-center justify-center p-1">
          <NuxtImg
            :src="bank.icon"
            :alt="`Logo Bank ${bank.bank_name}`"
            class="w-24 h-auto md:w-28"
            loading="lazy"
            decoding="async"
          />
        </span>

        <div class="flex flex-col gap-1 mt-3 text-base sm:text-lg md:text-xl lg:text-2xl">
          <h6 class="text-center font-medium text-primary-800">
            {{ bank.account_name }}
          </h6>

          <p class="text-center font-medium">
            {{ bank.account_number }}
          </p>
        </div>

        <UButton
          label="Salin Rekening"
          variant="subtle"
          color="primary"
          class="mt-4"
          @click="onCopyAccountNumber(bank.account_number)"
        />
      </li>
    </ul>
  </section>
</template>
